export default __webpack_public_path__ + "static/media/90.cab6048c.jpg";